import { render, staticRenderFns } from "./Classroom.vue?vue&type=template&id=6070753b&scoped=true"
import script from "./Classroom.vue?vue&type=script&lang=js"
export * from "./Classroom.vue?vue&type=script&lang=js"
import style0 from "./Classroom.vue?vue&type=style&index=0&id=6070753b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6070753b",
  null
  
)

export default component.exports